import React, { createContext, useReducer } from 'react'

const initialState = {
    status: 200,
    title: "",
    message: "",
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_ERROR': {
            return {
                ...state,
                error: action.payload
            }
        }
        default: {
            return { ...state }
        }
    }
}

const ErrorContext = createContext({
    error: initialState,
    setError: () => Promise.resolve(),
})

export const ErrorProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const setError = async ({title, message, status}) => {
        dispatch({
            type: 'SET_ERROR',
            payload: {
                status,
                message,
                title
            },
        })
    }

    return (
        <ErrorContext.Provider
            value={{
                ...state,
                setError
            }}
        >
            {children}
        </ErrorContext.Provider>
    )
}

export default ErrorContext
